import { c as setLoaderClientConfig, d as setLoaderVariant, l as setLoaderComlink, u as setLoaderPerspective } from "./VisualEditing-CdJu-qkj.js";
import { c } from "react/compiler-runtime";
import { createCompatibilityActors } from "@sanity/presentation-comlink";
import { useEffect } from "react";
import { createNode, createNodeMachine } from "@sanity/comlink";
/**
* Creates a loader comlink node that connects to the Presentation Tool.
* This enables `usePresentationQuery` to communicate with the Presentation Tool
* for running queries and receiving live updates.
* @internal
*/
function LoaderComlink() {
	let $ = c(1), t0;
	return $[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = [], $[0] = t0) : t0 = $[0], useEffect(_temp2, t0), null;
}
function _temp2() {
	let loaderComlink = createNode({
		name: "loaders",
		connectTo: "presentation"
	}, createNodeMachine().provide({ actors: createCompatibilityActors() }));
	loaderComlink.on("loader/perspective", _temp);
	let stop = loaderComlink.start();
	return setLoaderComlink(loaderComlink), () => {
		stop(), setLoaderComlink(null), setLoaderClientConfig(null, null), setLoaderPerspective(null), setLoaderVariant(null);
	};
}
function _temp(data) {
	setLoaderClientConfig(data.projectId, data.dataset), setLoaderPerspective(data.perspective), setLoaderVariant(data.variant ?? null);
}
LoaderComlink.displayName = "LoaderComlink";
export { LoaderComlink as default };

//# sourceMappingURL=LoaderComlink-DeCFIlRj.js.map